// ============================================================
// ANSICHTSSACHE-AGENT – Toast (Sonner Wrapper)
// ============================================================
// Nutzung: toast.success("Gespeichert") / toast.error("Fehler")
// <Toaster /> muss im Root-Layout eingebunden sein.
// ============================================================

"use client";

import { Toaster as SonnerToaster } from "sonner";

// Eine einzeilige Meldung ist 53.5px hoch, die Blase 48px: knapp
// 3px unter ihrem Stand stehen beide auf derselben Mitte. Eine
// Meldung mit zweiter Zeile waechst nach oben.
const TOAST_OFFSET = {
  bottom: "calc(var(--ans-chatblase) - 2.75px)",
  right: "5rem",
};

function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      // Unten rechts sitzt die Chat-Blase (`components/chat/chat-dock.tsx`).
      // Die Meldung steht links daneben, auf ihrer Hoehe: rechts
      // der Abstand der Blase (1.25rem) plus ihre Breite (3rem) und
      // etwas Luft, unten gerechnet mit demselben Wert, mit dem die
      // Blase steht (`--ans-chatblase`).
      // Darueber laege sie auf dem unteren Rand des Chatfensters,
      // auf der Blase wuerde man sie quittieren, indem man den Chat
      // oeffnet.
      offset={TOAST_OFFSET}
      // Unter 600 Pixeln rechnet Sonner mit eigenem Abstand (16px)
      // und laege dann wieder auf der Blase — auf dem iPhone gilt
      // dieselbe Rechnung. Die Breite gibt Sonner dort selbst vor;
      // dass sie vor der Blase endet, regelt `styles/globals.css`.
      mobileOffset={{ ...TOAST_OFFSET, left: "1rem" }}
      toastOptions={{
        className:
          "!bg-bg-primary !border-border !text-text-primary !text-body-sm !shadow-dropdown !rounded",
        descriptionClassName: "!text-text-secondary !text-caption",
      }}
    />
  );
}

export { Toaster };
// Re-export toast function from sonner for convenience
export { toast } from "sonner";
